<template>
    <div>
      <v-menu transition="slide-y-transition"
              left
              v-ripple="false"
              bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="tab-menu__button flat-btn"
                 small
                 fab
                 v-ripple="false"
                 absolute
                 top
                 right
                 v-on="on"
                 transition="scroll-y-transition"
                 color="transparent">
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list class="list__menu list__menu--lefty">
          <v-list-item class="list__menu-item">
            <v-list-item-title class="list__menu-text">
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="!community.is_locked" v-ripple @click="editDialog = true" class="list__menu-item">
            <v-list-item-title class="list__menu-text">
              <v-img :src="require('@/assets/img/icons/pen.svg')"></v-img>
              <span>Edit</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="is_temporary" v-ripple @click="saveDialog = true" class="list__menu-item">
            <v-list-item-title class="list__menu-text">
              <v-img :src="require('@/assets/img/icons/save.svg')"></v-img>
              <span>Save</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="can_unlock && community.is_locked" v-ripple @click="unlockCommunity()" class="list__menu-item">
            <v-list-item-title class="list__menu-text">
              <v-img :src="require('@/assets/img/icons/lock.svg')"></v-img>
              <span>Unlock</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="can_lock && !community.is_locked" v-ripple @click="lockCommunity()" class="list__menu-item">
            <v-list-item-title class="list__menu-text">
              <v-img :src="require('@/assets/img/icons/lock.svg')"></v-img>
              <span>Lock</span>
            </v-list-item-title>
          </v-list-item>

          <DeleteCommunity v-if="!community.is_locked" :name="community.label" @delete="deleteCommunity"
            @opened="updateDependandAnalyses()" >
                  <template v-if="dependant_analyses" v-slot:additional_info>
                    <h3>Dependand analyses will also be deleted:</h3>
                    <ul>
                      <li v-for="dependant_analysis in dependant_analyses">
                        {{dependant_analysis.type}} - {{dependant_analysis.label}}
                      </li>
                    </ul>
                  </template>
          </DeleteCommunity>
        </v-list>
      </v-menu>

      <v-dialog v-model="editDialog" width="900">
        <EditCommunity :key="project.id" v-model="community.query"
                       @confirm="editCommunity" @cancel="editDialog = false">
        </EditCommunity>
      </v-dialog>
      <v-dialog v-model="saveDialog" width="900">
        <SaveCommunity
          :query="community.query"
          :initial_namespace=null
          :initial_name="community.label"
          @confirm="saveCommunity($event)"
        >
        </SaveCommunity>
      </v-dialog>
    </div>
</template>

<script>
    import {store} from '../../../../store/store'
    import CommunityService from "../../../../services/community.service";
    import DeleteCommunity from "../../../DeleteCommunity";
    import EditCommunity from "../../../Community/EditCommunity";
    import SaveCommunity from "../../../Community/SaveCommunity";
    import {getDependantAnalyses, projectCan} from '../../../../services/project.service';

    export default {
        name: "ProjectFiltersCommunityMenu",
        props: ['project', 'community', 'is_temporary'],
        components: { DeleteCommunity, EditCommunity, SaveCommunity },
        data: () => ({
            editDialog: false,
            dialog: null,
            saveDialog: false,
            nonedited_community_query: null,
            dependant_analyses: null,
            CommunityService,
            can_lock: false,
            can_unlock: false,
        }),
        computed: {
        },
        methods: {
            updateDependandAnalyses: function () {
              getDependantAnalyses(this.project.id, this.community.id)
              .then(dep_analyses => {
                this.dependant_analyses = dep_analyses.length > 0 ? dep_analyses : null;
              })
            },
            editCommunity: function (q) {
                if ( this.nonedited_community_query != q) {
                  store.dispatch('updateCommunityInProject',
                                 {projectId: this.project.id,
                                  communityId: this.community.id,
                                  community: {
                                    query: q,
                                    is_temporary: true,
                                  }
                                  })
                  .then(resp => {
                    // After save this is the new nonedited value
                    this.nonedited_community_query = q;
                  })
                }
                else {
                  console.log("no changes in community query detected. Skipping update.")
                }
                this.editDialog = false
            },
            saveCommunity: function (community_to_save) {
                console.log("ProjectFiltersCommunityMenu > saveCommunity", community_to_save);
                // store community
                let community = {
                  name: {
                    namespace: community_to_save.namespace,
                    name: community_to_save.name,
                  },
                  query: community_to_save.query,
                }
                store.dispatch('addCommunity', community)
                    .then(resp => {
                        this.saveDialog = false
                    })
                    .catch(err => {
                        console.log("Cought error in addCommunity")
                    });
            },
            deleteCommunity () {
                store.dispatch('deleteCommunityFromProject',
                               {projectId: this.project.id,
                                communityId: this.community.id})
            },
            lockCommunity() {
                store.dispatch('lockCommunityInProject',
                               {projectId: this.project.id,
                                communityId: this.community.id})

            },
            unlockCommunity() {
                store.dispatch('unlockCommunityInProject',
                               {projectId: this.project.id,
                                communityId: this.community.id})
            }
        },
        mounted() {
            this.CommunityService = new CommunityService();
            this.nonedited_community_query = this.community.query;

            // Checking permissions
            console.log("project.domain_id: " + this.project.domain_id);
            if (projectCan('lock_project_community', this.project.domain_id, this.project.id)) {
                this.can_lock = true;
            }
            if (projectCan('unlock_project_community', this.project.domain_id, this.project.id)) {
                this.can_unlock = true;
            }
        }
    }
</script>

<style scoped>

</style>
